/**
 * Fee statement of a project (AP-107): per position the agreed fee, the
 * progress, what has been earned and billed - the groundwork of an interim
 * invoice, not an invoice (A-51). Pure, used by server and browser.
 */
const round2 = (v) => Math.round(v * 100) / 100;
export function feeRows(categories) {
    const rows = categories.filter((c) => !c.unpaid || c.fee !== null).map((c) => {
        const earned = c.fee === null || c.progress === null ? null : round2((c.fee * c.progress) / 100);
        const billed = c.billed ?? 0;
        return { ...(c.id ? { id: c.id } : {}), code: c.code, label: c.label, fee: c.fee, progress: c.progress, earned, billed, open: earned === null ? null : round2(earned - billed), budgetHours: c.budgetHours, booked: c.booked };
    });
    const sum = (f) => round2(rows.reduce((s, r) => s + (f(r) ?? 0), 0));
    return { rows, total: { fee: sum((r) => r.fee), earned: sum((r) => r.earned), billed: sum((r) => r.billed), open: sum((r) => r.open) } };
}
//# sourceMappingURL=time-fees.js.map